import {
  Grid,
  Divider,
  Radio,
  RadioGroup,
  FormControl,
  FormControlLabel,
} from "@mui/material";
import React, { Fragment } from "react";

const ActionDropdown = ({
  table,
  reactionsInOrg,
  handleClick,
  dropdownRef,
  options,
  currentValue,
  areaManagement,
}) => {
  return (
    <Grid
      ref={dropdownRef}
      style={{
        ...mainContainerStyles,
        right: reactionsInOrg ? undefined : table ? (areaManagement ? 0 : 10) : undefined,
        left: areaManagement ? 600 : undefined,
      }}
    >
      <Grid container direction={"column"}>
        <FormControl>
          <RadioGroup
            row
            aria-labelledby="demo-form-control-label-placement"
            name="position"
            value={currentValue}
          >
            {options ? (
              options.map((option, index) => (
                <Fragment>
                  <FormControlLabel
                    value={option}
                    key={index}
                    style={{
                      ...radioStyles,
                      color:
                        option == "accepted"
                          ? "#128D1F"
                          : option == "pending"
                          ? "#E48900"
                          : option == "declined"
                          ? "#BA344C"                                                    
                          : option == "automatic"
                          ? "#1e49c0ff"
                          : "#000",

                    }}
                    control={<Radio style={{ marginLeft: "auto" }} />}
                    label={option}
                    labelPlacement="start"
                    onClick={() => handleClick(option)}
                  />
                  <Divider style={dividerStyles} />
                </Fragment>
              ))
            ) : (
              <Fragment>
                <FormControlLabel
                  value="approved"
                  style={{ ...radioStyles, color: "#128D1F" }}
                  // style={{ width: "90%", fontFamily: "Avenir Book, sans-serif" }}
                  control={<Radio style={{ marginLeft: "auto" }} />}
                  label="Approved"
                  labelPlacement="start"
                  onClick={() => handleClick("approved")}
                />
                <Divider style={dividerStyles} />
                <FormControlLabel
                  value="pending"
                  style={{ ...radioStyles, color: "#E48900" }}
                  control={<Radio style={{ marginLeft: "auto" }} />}
                  label="Pending"
                  labelPlacement="start"
                  onClick={() => handleClick("pending")}
                />
                <Divider style={dividerStyles} />
                <FormControlLabel
                  value="denied"
                  style={{ ...radioStyles, color: "#BA344C" }}
                  control={<Radio style={{ marginLeft: "auto" }} />}
                  label="Denied"
                  labelPlacement="start"
                  onClick={() => handleClick("denied")}
                />
                <Divider style={dividerStyles} />
                <FormControlLabel
                  value="removed"
                  style={{ ...radioStyles, color: "#000" }}
                  control={<Radio style={{ marginLeft: "auto" }} />}
                  label="Removed"
                  labelPlacement="start"
                  onClick={() => handleClick("removed")}
                />
              </Fragment>
            )}
          </RadioGroup>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default ActionDropdown;

const mainContainerStyles = {
  width: 160,
  // height: 144,
  zIndex: 1,
  position: "absolute",
  border: "1px solid #BABABA",
  borderRadius: 5,
  background: "#fff",
};

const dividerStyles = {
  width: "100%",
};

const radioStyles = {
  width: "90%",
  fontFamily: "Avenir Book, sans-serif",
  textTransform: "capitalize",
};
